import styled from "styled-components";

import { FlexDiv, Header } from "@/components/Atoms/Box";

import Typography from "@/foundation/Typography/V2";

export const DropDownOuter = styled(FlexDiv)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  min-width: 247px;
  opacity: 0;
  padding-top: 50px;
  visibility: hidden;
  top: 100%;
  transition: all 0.2s ease-in-out;
`;

export const MenuHeader = styled(Typography)`
  transition: all 0.2s ease-in-out;
  color: ${({ theme, darkHeader }) =>
    darkHeader ? theme.colorsV2.gray.shade_100 : theme.colorsV2.gray.shade_600};
`;

export const DropDownWrap = styled(FlexDiv)`
  &:hover {
    ${DropDownOuter} {
      opacity: 1;
      visibility: visible;
    }
    ${MenuHeader} {
      color: ${({ theme, darkHeader }) =>
        darkHeader
          ? theme.colorsV2.gray.shade_100
          : theme.colorsV2.primary.shade_800};
    }
  }
  ${({ isLastElement }) =>
    isLastElement &&
    `
    ${DropDownOuter} {
      left: auto;
      right: 0;
      transform: none;
      ${DropDown} {
        &:after {
          left: unset;
          right: 45px;
          transform: translateX(0) rotate(45deg);
        }
      }
    }
  `}
`;

export const HeaderWrapper = styled(Header)<{ [key: string]: any }>`
  display: flex;
  transition: all 0.3s ease-in-out;
  flex-direction: column;
`;
